import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CreateBookingType from './../Createbookingtype';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import BookingService from './../../../services/cargobooking.service';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { BasicSelect,MultiSelect } from 'vue-search-select';
import TripServices from '../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import XLSX from 'xlsx';
const moment = require('moment');

export default {
  name: 'PincodeAllocationdetails',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CreateBookingType,
    CustomExpandableTable,
    Treeselect,
    BasicSelect,
    MultiSelect
  },
  data: function() {
    return {
      tableColumn:['Pincode','Area Route Code','HubName','SVC Code','HubCity','HubState','HubZone','Business Unit','Business Flow','Service Type','Business Service','IsActive'],
      tableItems:[],
      HubList:[],
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      selectedHub:{value:'',text:''},
      hubname:'',
      pageLimit:CONSTANT.PER_PAGE_DATA,
      hubzone:null,
      businessunitlist: [
        {
          id: 'Cargo',
          label: 'Cargo'
        },
        {
          id: 'CargoAir',
          label: 'CargoAir'
        }
      ],
      businessunit:null,
      businessservicelist: [
        {
          id: 'PickUp',
          label: 'PickUp'
        },
        {
          id: 'Delivery',
          label: 'Delivery'
        }
      ],
      businessservice:null,
      statelist: [],
      selectedstate: {
        text: '',
        value: ''
      },
      state: '',
      citylist: [],
      selectedcity: {
        text: '',
        value: ''
      },
      city: '',
	    pincode: '',
  	  cityid:'',
  	  hubzonename:'',
  	  disableClear: false,
  	  isDownloadData: true,
  	  searchFilter: false
    }
  },
  computed: {
  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubID = userdetail.hubID[0];
    this.isLoading = true;
    await Promise.all([
      this.getHublist(),
      this.getStateList()
    ]);
    this.isLoading = false;
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    selectedbusinessservice(data) {
      this.businessservice = data;
      this.businessservice = data.value;
    },
    async resetField() {
      try {
        this.currentPage = 1;
        this.offset = 0;
        this.isLoading = false;
        this.businessunit = null;
        this.businessservice = null;
        this.selectedstate = '';
        this.selectedcity = '';
        this.selectedHub= '';
        this.pincode = null;
        this.city =null;
        this.state =null;
        this.hubname='';
        this.dataArray = [];
        this.tableItems=[];
        this.isDownloadData = true;
        this.searchFilter = false;
        this.totalCount = 0;
    		this.citylist=[];
      } catch (error) {
        console.log(error)
      }
    },
    selectHub(data){
      this.selectedHub = data;
      this.hubname = data.value;
    },
    async getHublist() {
      try {
          let InputPayload = {};
          let result = await MasterService.GetHublist(InputPayload);
          let HubList = result.data.data.data;
          for (var i = 0; i < HubList.length; i++) {
            this.HubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
            });
          }
      } catch (err) {
        console.log(err);
      }
    },
    selectState(selectedstate) {
      this.selectedstate = selectedstate;
      this.state = selectedstate.value;
      this.citylist = [];
      this.selectedcity = {
        text: '',
        value: ''
      }
      this.city = ''
      if (this.state != '') {
        this.getCityList(selectedstate.value)
      }
    },
    async getCityList(stateid) {
      var citystateregionlist = []
      try {
        this.isLoading = true;
        let inputPayload = {
        "stateId": [stateid]
        }
        let result = await MasterService.getCityList(inputPayload)
        this.isLoading = false;
        citystateregionlist = result.data.data
        for (var i = 0; i < citystateregionlist.length; i++) {
          this.citylist.push({
          'value': citystateregionlist[i].cityid,
          'text': citystateregionlist[i].cityname
         });
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectCity(selectedcity) {
      this.selectedcity = selectedcity;
      this.city = selectedcity.value;
    },
    async getStateList(){
      let stateregionlist = []
      try {
        let result = await MasterService.getStateList()
        this.isLoading = false;
        stateregionlist = result.data.data
        for (var i = 0; i < stateregionlist.length; i++) {
          this.statelist.push({
          'value': stateregionlist[i].stateid,
          'text': stateregionlist[i].statename
          });
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    onSubmitSearch(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.currentPage = 1;
          this.offset = 0;
          this.searchPincodeMapping();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    async searchPincodeMapping(){
      try {
        this.isLoading = true;
        this.searchFilter = true;
        let payload = {
          "pageno":this.currentPage,
          "limit": this.pageLimit
        }
        if(this.businessunit){
          payload.businessunit = this.businessunit
        }
        if(this.businessservice){
          payload.businessservice = this.businessservice
        }
        if(this.hubname){
          payload.hubid = this.hubname
        }
        if(this.state) {
          payload.state = this.selectedstate.text
        }
        if(this.city) {
          payload.city = this.selectedcity.text
        }
        if(this.pincode){
          payload.pincode = this.pincode;
        }

        let result = await MasterService.getPinCodeAllocationList(payload);
        let id = 1;
        if (result && result.data.code == 200) {
          this.totalCount = parseInt(result.data.data.count);
          this.dataArray = result.data.data.data;
          this.tableItems = this.dataArray.map((el) => {
          return {
            'id':id,
            'Sr.No.': id,
            'Pincode' : el.pincode,
            'Area Route Code' : el.AreaCode,
            'HubName' : el.HubName,
            'SVC Code' : el.SVCCode,
            'HubCity' : el.HubCity,
            'HubState' : el.HubState,
            'HubZone' : el.HubZone,
            'Business Unit' : el.businessunit,
            'Business Flow' : el.businessflow,
            'Service Type' : el.servicetype,
            'Business Service' : el.businessservice,
            'IsActive' : el.isactive
            }
            id++;
          });
          this.isLoading = false;
          this.isDownloadData = false;
        } else {
          this.$alertify.error("Data not found");
          this.isDownloadData = true;
          this.dataArray = [];
          this.tableItems = [];
          this.isLoading = false;
        }
        if (this.totalCount < this.pageLimit) {
          this.isLoading = false;
          this.totalPage = 1;
        } else {
          this.isLoading = false;
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch (error) {
        console.log("Error",error)
      }
    },
    async pinCodedReport(){
      try {
        this.isLoading = true;
        let pagelimit = 200;
        let temparr = [];
        if(this.searchFilter) {
          let totalpagecount = Math.ceil(this.totalCount/pagelimit);
          let promiseResult = [];
          for(let i=1; i<=totalpagecount; i++){
            let inputPayload1 = {
              "pageno": i,
              "limit": pagelimit
            }
            if(this.businessunit){
              inputPayload1.businessunit = this.businessunit
            }
            if(this.businessservice){
              inputPayload1.businessservice = this.businessservice
            }
            if(this.hubname){
              inputPayload1.hubid = this.hubname
            }
            if(this.state) {
              inputPayload1.state = this.selectedstate.text
            }
            if(this.city) {
              inputPayload1.city = this.selectedcity.text
            }
            if(this.pincode){
              inputPayload1.pincode = this.pincode;
            }
            promiseResult.push(MasterService.getPinCodeAllocationList(inputPayload1));
          }
          let newResult = await Promise.all(promiseResult);
          for(let j=0; j<newResult.length; j++){
            let pincodelist1 = newResult[j].data.data.data;
            pincodelist1.forEach((item)=>{
              temparr.push({
                'Pincode' : item.pincode,
                'Area Route Code' : item.AreaCode,
                'HubName' : item.HubName,
                'SVC Code' : item.SVCCode,
                'HubCity' : item.HubCity,
                'HubState' : item.HubState,
                'HubZone' : item.HubZone,
                'Business Unit' : item.businessunit,
                'Business Flow' : item.businessflow,
                'Service Type' : item.servicetype,
                'Business Service' : item.businessservice,
                'IsActive' : item.isactive
              });
            });
          }
          return temparr;
        }else{
          let promiseResult = [];
          let inputPayloadCargoPickup = {
            "pageno": 1,
            "limit": 10,
            "businessunit":"Cargo",
            "businessservice":"PickUp"
          }
          let inputPayloadCargoDelivery = {
            "pageno": 1,
            "limit": 10,
            "businessunit":"Cargo",
            "businessservice":"Delivery"
          }
          let inputPayloadCargoAirPickup = {
            "pageno": 1,
            "limit": 10,
            "businessunit":"CargoAir",
            "businessservice":"PickUp"
          }
          let inputPayloadCargoAirDelivery = {
            "pageno": 1,
            "limit": 10,
            "businessunit":"CargoAir",
            "businessservice":"Delivery"
          }
          promiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoPickup));
          promiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoDelivery));
          promiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoAirPickup));
          promiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoAirDelivery));
          let newResult = await Promise.all(promiseResult);

          let totalpagecountCargoPickup = Math.ceil(newResult[0].data.data.count/pagelimit);
          let totalpagecountCargoDelivery = Math.ceil(newResult[1].data.data.count/pagelimit);
          let totalpagecountCargoAirPickup = Math.ceil(newResult[2].data.data.count/pagelimit);
          let totalpagecountCargoAirDelivery = Math.ceil(newResult[3].data.data.count/pagelimit);

          let newPromiseResult = [];
          for(let i=1; i<=totalpagecountCargoPickup; i++){
            let inputPayloadCargoPickup1 = {
              "pageno": i,
              "limit": pagelimit,
              "businessunit":"Cargo",
              "businessservice":"PickUp"
            }
            newPromiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoPickup1));
          }

          for(let i=1; i<=totalpagecountCargoDelivery; i++){
            let inputPayloadCargoDelivery1 = {
              "pageno": i,
              "limit": pagelimit,
              "businessunit":"Cargo",
              "businessservice":"Delivery"
            }
            newPromiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoDelivery1));
          }
          for(let i=1; i<=totalpagecountCargoAirPickup; i++){
            let inputPayloadCargoAirPickup1 = {
              "pageno": i,
              "limit": pagelimit,
              "businessunit":"CargoAir",
              "businessservice":"PickUp"
            }
            newPromiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoAirPickup1));
          }
          for(let i=1; i<=totalpagecountCargoAirDelivery; i++){
            let inputPayloadCargoAirDelivery1 = {
              "pageno": i,
              "limit": pagelimit,
              "businessunit":"CargoAir",
              "businessservice":"Delivery"
            }
            newPromiseResult.push(MasterService.getPinCodeAllocationList(inputPayloadCargoAirDelivery1));
          }
          let newResult1 = await Promise.all(newPromiseResult);
          for(let k=0; k<newResult1.length; k++){
            let pincodelist1 = newResult1[k].data.data.data;
            pincodelist1.forEach((item)=>{
              temparr.push({
                'Pincode' : item.pincode,
                'Area Route Code' : item.AreaCode,
                'HubName' : item.HubName,
                'SVC Code' : item.SVCCode,
                'HubCity' : item.HubCity,
                'HubState' : item.HubState,
                'HubZone' : item.HubZone,
                'Business Unit' : item.businessunit,
                'Business Flow' : item.businessflow,
                'Service Type' : item.servicetype,
                'Business Service' : item.businessservice,
                'IsActive' : item.isactive
              });
            });
          }
          return temparr;
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async exportPinCodeDetails(){
      try {
        let pinCodeDetails = await this.pinCodedReport();
        const wb = XLSX.utils.book_new();
        if(pinCodeDetails){
          const pincodeData = XLSX.utils.json_to_sheet(pinCodeDetails)
          XLSX.utils.book_append_sheet(wb, pincodeData, 'data')
          let reportName = "PinCodeAllocationreport"
          let xlsFileName = `${reportName}_`+`_${moment().format('YYYY-MM-DD')}.xlsx`;
          XLSX.writeFile(wb, xlsFileName);
          this.isLoading = false;
          return this.$alertify.success("Report Downloaded Successfully");
        }else{
          this.isLoading = false;
          return this.$alertify.error("Record Not Found");
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error",error);
        return this.$alertify.error("Something went wrong");
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.searchPincodeMapping();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/pincodeallocationdetails/pincodeallocationdetails.component.js